export const environment = {
  production: false,
  // apiUrl: 'https://devesignapi.ihostmyform.com/api',
  apiUrl: 'https://api-saas-esign.avsstech.in/api',
  // apiUrl: 'http://192.168.1.126:3000/api',
  otherUrl: '',

  defaultauth: 'fackbackend',
};